import { type AccentColor } from '@atlaskit/lozenge/types';

/**
 * Preserve stored dark/light colors across independent legacy and read-only views.
 * Unknown or absent colors retain the legacy neutral appearance.
 */
const lozengeAppearanceBySelectOptionColor = {
  blueDark: 'accent-blue',
  blueLight: 'accent-blue',
  redDark: 'accent-red',
  redLight: 'accent-red',
  yellowDark: 'accent-yellow',
  yellowLight: 'accent-yellow',
  greenDark: 'accent-green',
  greenLight: 'accent-green',
  tealDark: 'accent-teal',
  tealLight: 'accent-teal',
  purpleDark: 'accent-purple',
  purpleLight: 'accent-purple',
  greyDark: 'accent-gray',
  greyLight: 'accent-gray',
  limeDark: 'accent-lime',
  limeLight: 'accent-lime',
  magentaDark: 'accent-magenta',
  magentaLight: 'accent-magenta',
  orangeDark: 'accent-orange',
  orangeLight: 'accent-orange'
} satisfies Record<string, AccentColor>;

type SelectOptionTagColor = keyof typeof lozengeAppearanceBySelectOptionColor;

export const getLozengeAppearance = (color: string | undefined): AccentColor => {
  if (!color) {
    return 'accent-gray';
  }

  return (
    lozengeAppearanceBySelectOptionColor[color as SelectOptionTagColor] ?? 'accent-gray'
  );
};
